import { sendRequest } from './index';
import { API_CORE_URL } from '@core/constants/API';

export const GetExperts = (params = {}) => {
	const cleanParams = Object.keys(params).reduce((acc, key) => {
		const value = params[key];
		if (value !== undefined && value !== null && value !== '') {
			acc[key] = value;
		}
		return acc;
	}, {});
	return sendRequest({
		url: `${API_CORE_URL}experts`,
		method: 'GET',
		params: cleanParams
	});
};

export const GetExpert = (id) => {
	return sendRequest({
		url: `${API_CORE_URL}experts/${id}`,
		method: 'GET'
	});
};
